module.exports = __webpack_public_path__ + "img/0.5.0e730a23.png";